import { defineMessage } from 'services/localization';

export const messages = {
    acceptedRequest: defineMessage('the_request_has_been_accepted'),
    declinedRequest: defineMessage('the_request_has_been_declined'),
    unavailableQuoteError: defineMessage('the_customers_decision__een_deleted_within_xero'),
};
